
// src/connects/groups-page.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import { getArray } from '../helpers/store'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import actions from '../actions'
import GroupIdStore from '../actions/group-id-store'
import socketRsync from '../helpers/socket-rsync'
import { replaceRoute } from '../actions/route'
import { inject } from '../helpers/context'

export const mapStateToProps = (state, ownProps)=> {
  return {
    user: state.user.current,
    group: getArray('group_id', state.groups.items, ownProps.params.group_id),
    current: state.savedDiaries.current,
    isFetchGroupFailed: state.groups.isFetchGroupFailed,
    rightSidePage: state.rightSidePage,
    groupSettings: state.groupSettings,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    willMount: (props)=> {
      dispatch(actions.fetchGroup(ownProps.params.group_id))
      dispatch(actions.fetchGroupUnreadCount(ownProps.params.group_id))
      dispatch(actions.fetchNotificationsUnreadCount(ownProps.params.group_id))
      GroupIdStore.set(ownProps.params.group_id)
    },

    willUnmount: ()=> {
      dispatch(actions.clearPreservedQueries())
      dispatch(actions.clearKpis())
      dispatch(actions.closeRightSidePage(true))
    },

    willUpdate: (props, nextProps)=> {
			if (!nextProps.group) {
				replaceRoute('main')
			}

      if (props.params.group_id != nextProps.params.group_id) {
        dispatch(actions.fetchGroup(nextProps.params.group_id))
        dispatch(actions.fetchGroupUnreadCount(nextProps.params.group_id))
        dispatch(actions.fetchNotificationsUnreadCount(nextProps.params.group_id))
        GroupIdStore.set(nextProps.params.group_id)
      }

      if (props.isFetchGroupFailed != nextProps.isFetchGroupFailed && nextProps.isFetchGroupFailed) {
        dispatch(actions.fetchGroups())
      }
    },

    receiveSocket: (message)=> {
      if (message.group_id == ownProps.params.group_id)
        dispatch(actions.loadNotificationUnreadCount(message.group_id, message.count))
    },

    requestSync: ()=> {
      dispatch(actions.fetchNotificationsUnreadCount(ownProps.params.group_id))
      dispatch(actions.fetchGroup(ownProps.params.group_id))
      dispatch(actions.fetchGroupUnreadCount(ownProps.params.group_id))
    },
    openDiaryForms: (props)=> dispatch(actions.openRightSidePage('create_diary', { group: props.group })),
    openSearchDrawer: (props)=> dispatch(actions.openRightSidePage('search_drawer', { group: props.group })),
    closeRightSidePage: (force)=> dispatch(actions.closeRightSidePage(force)),
    closeGroupSettingsPage: ()=> dispatch(actions.closeGroupSettingsPage()),
    // webでsearch-drawerを開くために必要
    editSearchDrawer: (props)=> props.updateUI({ openDrawer: true }),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  socketRsync('notification'),
  ui({ state: {
    active: false,
    openAlbum: false,
    openPdf: false,
    openDrawer: false,
  }}),
  lifecycle,
  translate(),
  inject({ editSearchDrawer: PropTypes.func }),
)



// WEBPACK FOOTER //
// ./src/connects/groups-page.js